import * as React from "react";
import { IconButton, Menu } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { wait } from "@testing-library/user-event/dist/utils";
import { GetAppraisalModel, AppraisalTask } from "all_Interfaces";
import { AlertDialog } from "components/util/Dialog";
import { AppraisalReviewServiceURL, TaskmgmtServiceURL } from "config/config";
import { ServiceName } from "../../../constants";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import DeleteIcon from "@mui/icons-material/Delete";
import ListIcon from "@mui/icons-material/List";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getApiCall, postApiCall } from "services/apiHelper";
import PrintToPDF from "../us/print/printToPdf";
import DirectionsIcon from "@mui/icons-material/Directions";


type MenuItem = {
    key: number;
    label: string;
    icon: React.ReactElement;
    action: () => void;
  };

export const GlobalHamburger = (props: any) => {
    const navigate = useNavigate();
    const [appraisalId, setAppraisalId] = useState<string>("");
    const menuItems: MenuItem[] = [];
    const [loading, setLoading] = useState<boolean>(false);
    const [deleteAppraisalMenu, setDeleteAppraisalMenu] =
      useState<boolean>(false);
    const [deleteAndArchiveAppraisalMenu, setDeleteAndArchiveAppraisalMenu] =
      useState<boolean>(false);
    const [loadRevokeappraisalmenu, setLoadRevokeappraisalmenu] =
      useState<boolean>(false);
    const [loadrecallappraisalmenu, setLoadrecallappraisalmenu] =
      useState<boolean>(false);
  
    const [printToggle, setPrintToggle] = useState<boolean>(false);
    const [revokeToggle, setRevokeToggle] = useState<boolean>(false);
    const [deleteToggle, setDeleteToggle] = useState<boolean>(false);
    const [deleteAndArchiveToggle, setDeleteAndArchiveToggle] =
      useState<boolean>(false);
    const [recallToggle, setRecallToggle] = useState<boolean>(false);
  
    const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
    const [openDeleteAndArchiveDialog, setOpenDeleteAndArchiveDialog] =
      useState<boolean>(false);
    const [appraisalData, setAppraisalData] = useState<GetAppraisalModel>();
    const [open, setOpen] = useState(false);
  
    // const childRef = useRef(null);
  
    // const callChildFunction = () => {
    //   childRef?.current?.childFunction();
    // };
  
    useEffect(() => {
      setAppraisalId(props.appraisalId);
  
      fetchData();
    }, []);
  
    const fetchData = async () => {
      try {
        setLoading(true);
        await getApiCall(
          AppraisalReviewServiceURL + "/globalappraisals/getbyid/" + props.appraisalId,
          ServiceName.APPRAISALREVIEW
        )
          .then((data: any) => {
            var appraisalData = data.result[0];
            
            setLoadRevokeappraisalmenu(
              props.userContext.isAdmin && appraisalData.status === "Posted"
            );
            setDeleteAndArchiveAppraisalMenu(
              props.userContext.isAdmin && appraisalData.status != "Posted"
            );
            setAppraisalData(data.result);
            console.log(data.result);
          })
          .catch((e: any) => {
            console.log(e);
          })
          .finally(() => {
            console.log("finally ham burger");
            setLoading(false);
          });
      } catch (e) {
        console.log(e);
      }
    };

  
    const closeDialog = () => {
      setOpenDeleteDialog(false);
      setOpenDeleteAndArchiveDialog(false);
    };
  
    const deleteAndArchiveAppraisal = () => {
      var deleteAppraisalsArray: string[] = [];
      deleteAppraisalsArray.push(appraisalId);

      const payload = {
            Ids :deleteAppraisalsArray,
            UerEmail: props.userContext.email
      }

      postApiCall(
        AppraisalReviewServiceURL + "/globalappraisals/DeleteAndArchiveAppraisal",
        payload,
        ServiceName.APPRAISALREVIEW
      )
        .then((data: any) => {
          props.isSuccess({ isSuccess: true, message: "Appraisal has been Deleted" });
          setOpenDeleteAndArchiveDialog(false);
            wait(3000)
            .then(() => {
              props.isSuccess({ isSuccess: false, message: "" });
              navigate('/global/dashboard');
            });
        })
        .catch((e: any) => {
          props.isError({ isError: true, message: "Appraisal could not be Deleted" });
          setOpenDeleteAndArchiveDialog(false);
            wait(3000)
            .then(() => {
              props.isError({ isError: false, message: "" });
            });
        });
    };
  
    const enterRevokeToggle = () => {
      wait(500).then(() => {
      setRevokeToggle(true);
      });
    };
  
    const leaveRevokeToggle = () => {
      wait(500).then(() => {
      setRevokeToggle(false);
      });
    };
  
    const enterRecallToggle = () => {
      wait(500).then(() => {
      setRecallToggle(true);
      });
    };
  
    const leaveRecallToggle = () => {
      wait(500).then(() => {
      setRecallToggle(false);
      });
    };
  
    const enterDeleteToggle = () => {
      wait(500).then(() => {
      setDeleteToggle(true);
      });
    };
  
    const leaveDeleteToggle = () => {
      wait(500).then(() => {
      setDeleteToggle(false);
      });
    };
  
    const enterDeleteAndArchiveToggle = () => {
      wait(500).then(() => {
      setDeleteAndArchiveToggle(true);
      });
    };
  
    const leaveDeleteAndArchiveToggle = () => {
      wait(500).then(() => {
      setDeleteAndArchiveToggle(false);
      });
    };
  
    const enterPrintToggle = () => {
      wait(500).then(() => {
      setPrintToggle(true);
      });
    };
  
    const leavePrintToggle = () => {
      wait(500).then(() => {
      setPrintToggle(false);
      });
    };
  
    return (
      <>
        {
          <AlertDialog
            isOpen={openDeleteDialog}
            handleClose={closeDialog}
            onConfirm={props.deleteAppraisal}
            title={"Confirmation"}
            message={"Are you sure you want to delete this record?"}
          />
        }
  
        {
          <AlertDialog
            isOpen={openDeleteAndArchiveDialog}
            handleClose={closeDialog}
            onConfirm={deleteAndArchiveAppraisal}
            title={"Confirmation"}
            message={"Are you sure you want to delete this record?"}
          />
        }
  
       
  
        <PopupState variant="popover" popupId="demo-popup-menu">
        {(popupState) => (
          <React.Fragment>
            <IconButton
              style={{ fontSize: "100px", paddingTop: -4 }}
              {...bindTrigger(popupState)}
            >
              <ListIcon style={{ fontSize: "60px" }} sx={{ top: 0 }} />
            </IconButton>
  
            
            <Menu sx={{ fontSize: "small" }} {...bindMenu(popupState)}>
              
              {loadRevokeappraisalmenu && (
                <MenuItem onClick={() => {props.openRevokeDialog(true)}}>
                  <DirectionsIcon
                    sx={{ transform: "scaleX(-1)" }}
                    fontSize="small" color="action"
                  />{" "}
                  <span>&nbsp;Revoke</span>
                </MenuItem>
              )}
  
              {deleteAndArchiveAppraisalMenu && (
                <MenuItem onClick={() => {setOpenDeleteAndArchiveDialog(true)}}>
                  <DeleteIcon fontSize="small" color="action"/> <span>&nbsp;Delete</span>
                </MenuItem>
              )}
              
             
            </Menu>
          </React.Fragment>
        )}
      </PopupState>
      </>
    );
  };
  